<template>
	<div>
		<div class="profile-overview-card">
			<div class="profile-overview-card__icon">
				<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M45.84 71.5h2a1 1 0 000-2h-2a1 1 0 000 2zM57.84 84.5h-16a1 1 0 000 2h16a1 1 0 000-2z"/><path class="cls-1" d="M67.84 33.55v-15a1 1 0 00-1-1h-7a1 1 0 00-1 1v6.05L52.32 18a3.59 3.59 0 00-5 0L21 44.37a3.51 3.51 0 104.94 5l2.87-2.87v4.08a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3.06a3.48 3.48 0 000 6.94v3h-4a1 1 0 000 2h50a1 1 0 000-2h-4v-3a3.48 3.48 0 000-6.94v-3.11a3.48 3.48 0 000-6.94v-3.06a3.48 3.48 0 000-6.94v-4.08l2.87 2.87a3.52 3.52 0 104.95-5zm-7-14h5v12l-5-5zm-19 61h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm0-5h-11v-3h11zm0-5H29.09a1.5 1.5 0 010-3h12.75zm14 15h-12v-19h12zm1-21h-14a1 1 0 00-1 1h-11v-3h38v3h-11a1 1 0 00-1-1zm1 8h11v3h-11zm11 13h-11v-3h11zM72.09 74a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5H57.84v-3h12.75a1.5 1.5 0 011.5 1.5zm0-10a1.5 1.5 0 01-1.5 1.5h-41.5a1.5 1.5 0 010-3h41.5a1.5 1.5 0 011.5 1.5zm-34.25-8.5h-7v-1l1.95-2h5.05a1 1 0 000-2h-3.05l8-8h6.52a1 1 0 000-2h-4.52l5.05-5.05 15.06 15h-3.06a1 1 0 000 2h5.06l1.94 2v1h-7a1 1 0 000 2h7v3h-11v-12a1 1 0 00-1-1h-14a1 1 0 00-1 1v12h-11v-3h7a1 1 0 000-2zm13-1.5v-4.5h5V44zm5 2v4.5h-5V46zm-12-2v-4.5h5v4.55zm5 2v4.5h-5V46zm28.41 1.9a1.5 1.5 0 01-2.12 0L68 40.79 50.55 23.33a1 1 0 00-1.41 0l-7.47 7.46L24.56 47.9a1.5 1.5 0 11-2.12-2.12l26.34-26.34a1.5 1.5 0 012.13 0l26.34 26.34a1.51 1.51 0 010 2.12zM85.34 2h-9a3.52 3.52 0 00-3.5 3.5v2a1.5 1.5 0 01-1.5 1.5h-5a3.52 3.52 0 00-3.5 3.5v2a1 1 0 002 0v-2a1.5 1.5 0 011.5-1.5h5a3.5 3.5 0 003.5-3.5v-2a1.5 1.5 0 011.5-1.5h9a1 1 0 000-2z"/></svg>
			</div>
			<PageLoading v-if="loading" />
			<div
				class="profile-overview-card__booking-card"
				v-if="bookings.length > 0"
			>
				<h3 class="profile-overview-card__header">
					<span>{{ $t('profile.overviewBookingsTitle') }}</span>
					<span>({{ bookings.length }})</span>
				</h3>
				<span>
					<strong>{{ $t('profile.overviewBookingsTitle') }}</strong>
				</span>
			</div>
			<div
				v-if="bookings.length == 0 && loading == false"
				class="profile-overview-card__booking-card"
			>
				<h3 class="profile-overview-card__header">
					{{ $t('profile.overviewBookingsTitle') }}
				</h3>
				<span>
					<strong>{{ $t('profile.overviewNoBookingsSubtitle') }}</strong>
				</span>
				<span class="profile-overview-card__text">
					{{ $t('profile.overviewNoBookingsText') }}
					<router-link :to="{ name: 'search' }">
						{{ $t('navigation.accomodation') }}
					</router-link>
					<router-link :to="{ name: 'skipass' }">
						{{ $t('navigation.skipass') }}
					</router-link>
					<router-link :to="{ name: 'skirental' }">
						{{ $t('navigation.skirental') }}
					</router-link>
					{{ $t('profile.bookingAnd') }}
					<router-link :to="{ name: 'skischool' }">
						{{ $t('navigation.skischool') }}
					</router-link>
				</span>
				<router-link :to="{ name: 'search' }">
					<Button size="small">
						{{ $t('profile.overviewNoBookingsLink') }}
					</Button>
				</router-link>
			</div>
		</div>
		<div
			class="profile-overview-card__booking-item"
			v-for="booking in bookings"
			:key="booking.id"
		>
			<router-link
				class="profile-overview-card__bookinglink"
				:to="{
					name: 'booking',
					params: { id: booking.cancelled != 'T' ? booking.resvid : 'cancel' }
				}"
			>
				<h5 class="profile-overview-card__title">
					<span>{{ booking.resvid }}</span>
					<svg width="10" height="15" viewBox="0 0 10 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M7.89 8.525h-.001l-5.657 5.657-1.414-1.414L6.475 7.11.818 1.454 2.232.04l7.071 7.07L7.89 8.526z" fill="#7F8BA1" fill-rule="evenodd"/></svg>
				</h5>
				<span class="profile-overview-card__info">
					<span class="profile-overview-card__subtitle">
						{{ $t('profile.overviewBookingsNr') }}
					</span>
					<span class="profile-overview-card__bookingnr">
						{{ booking.resvid }}
					</span>
				</span>
				<span class="profile-overview-card__info">
					<span class="profile-overview-card__subtitle">
						{{ $t('profile.overviewBookingsPeriode') }}
					</span>
					<span v-if="booking.arrivaldate != null">
						{{ booking.arrivaldate.split(' ')[0] }}
					</span>
				</span>
			</router-link>
		</div>
	</div>
</template>

<script>
import store from '../../vueX/store'
import Button from '../../components/atoms/Button'
import PageLoading from '../../components/atoms/PageLoading'

export default {
	name: 'ProfileBookingsOverviewCard',
	store,
	components: {
		Button,
		PageLoading
	},
	props: {
		cardType: {
			type: String
		}
	},
	data() {
		return {
			bookings: [],
			loading: false
		}
	},
	methods: {},
	computed: {},
	created() {
		this.loading = true
		store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
			if (response) {
				store.dispatch('GET_BOOKINGS', store.state.user.id).then(success => {
					if (success) {
						this.bookings = success.reverse()
					}
					this.loading = false
				})
			} else {
				this.loading = false
			}
		})
	}
}
</script>

<style scoped lang="scss">
.profile-overview-card {
	background: #fff;
	padding: 60px 40px 15px 40px;
	position: relative;
	box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	text-align: center;
	@include for-tablet-portrait-up {
		padding: 60px 40px 40px 40px;
	}
	&__icon {
		width: 100px;
		height: 100px;
		border-radius: 100px;
		background: $colorPrimary6;
		top: 0;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: center;
		svg {
			fill: $colorWhite;
			width: 80px;
		}
	}
	&__actions {
		display: flex;
		justify-content: space-around;
	}
	&__booking-item {
		background: #fff;
		padding: 20px;
		margin: 10px 0;
		position: relative;
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	}
	&__header {
		font-size: 24px;
		letter-spacing: 0;
		line-height: 28px;
		font-weight: 400;
		margin-bottom: 10px;
		span {
			display: inline-block;
		}
		span:last-child {
			color: #949eb1;
			margin-left: 5px;
		}
	}
	&__bookinglink {
		display: block;
		&:hover,
		&:focus {
			text-decoration: none;
		}
		svg {
			height: 20px;
			width: 12px;
		}
	}
	&__title {
		font-weight: 400;
		margin-bottom: 10px;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	&__subtitle {
		color: #949eb1;
		font-size: 12px;
		letter-spacing: 0;
		line-height: 19px;
	}
	&__text {
		padding: 10px 0;
	}
	&__info {
		display: inline-block;
		margin-right: 20px;
		span {
			display: block;
		}
		span:last-child {
			color: #748097;
		}
	}
	&__bookingnr {
		font-weight: 600;
	}
}
</style>
